import { makeAutoObservable, runInAction } from 'mobx'
import { http } from '@/utils'

class RoleStore {

    //数据列表初始化
    dataList = [];

    //总条数
    total = '';

    //条数
    pagesize = 10;

    //当前页
    page = 1;


    //表单收集
    valueData = {}

    //弹框状态初始化
    isActive = false
    isOpen=false
    //弹框名字
    title = ''

    //配置列表
    configList = [];
    newCheckList = []
    indeterminate = true
    checkAll = true
    id = ''

    constructor() {
        makeAutoObservable(this)
    }
    //数据获取
    getDataList = async () => {
        const res = await http.get(`/adminapi/apigroup?page=${this.page}&limit=${this.pagesize}`)
        runInAction(() => {
            this.dataList = JSON.parse(JSON.stringify(res.data.rows))
            this.total = res.data.total
        })

    }

    //删除
    getDeleteButtom = async (id) => {
        const res = await http.delete(`/adminapi/apigroup/${id}`)
        if (res.status) {
            this.getDataList()
        }
    }

    //添加
    getAddButtom = async ({ name, describe }) => {
        const res = await http.post(`/adminapi/apigroup`, {
            name,
            describe,
            pid: 1,
            rules: 0,
            status: "normal",
        })
        if (res.status === 200) {
            this.getDataList()
        }
    }

    //修改
    getPutInformation = async (values) => {
        const res = await http.put(`/adminapi/apigroup/${this.valueData.id}`, values)
        if (res.status === 200) {
            this.getDataList()
        }
    }

    /* 处理新数据 */
    setCheckList = (checkBoxList) => {
        let newCheckList = []
        checkBoxList.map((element, index) => {
            let father = {
                id: element.id,
                father: element.name,
                isChecked: element.isCheckbox
            }
            let arrayOptions = []
            let arrayCheckList = []
            newCheckList.push(father)
            let options = {
                options: arrayOptions
            }
            let checkList = {
                checkList: arrayCheckList
            }
            if (element.hasOwnProperty('children') === true) {
                element.children.map((childrenElement) => {
                    let flag = false
                    if (childrenElement.isCheckbox === true) {
                        arrayCheckList.push(childrenElement.name)
                        flag = true
                    }
                    arrayOptions.push(childrenElement.name)
                })
            }
            Object.assign(father, options, checkList)
        })
        runInAction(() => {
            this.newCheckList = newCheckList
        })
        return newCheckList
    }

    //获取配置按钮信息
    getConfigPermission = async (id) => {
        const res = await http.get(`/adminapi/apigroup/${id}/edit`)
        runInAction(() => {
            this.configList = JSON.parse(JSON.stringify(res.data.data.menu_tree))
            this.setCheckList(JSON.parse(JSON.stringify(res.data.data.menu_tree)))
            this.id = id
        })
    }

}

export { RoleStore }